import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import styles from "./input.module.css";

const TextBoxInput = (props) => {
	const {
		question,
		field,
		hasError,
		errorMessage,
		hasOthersError,
		onOtherTextChange,
		optionId,
		onLogicChange,
		index,
		hasPhoneError1,
		hasPhoneError2,
	} = props;

	const numberValidationIds = process.env.REACT_APP_TF_NUMBER_IDS;
	const numberLogicIds = process.env.REACT_APP_TF_VALIDATION_IDS;
	const phoneNumberIds = process.env.REACT_APP_PHONE_NUMBER_IDS;
	const phoneNumberIdOne = process.env.REACT_APP_PHONE_NUMBER_ID_ONE;
	const phoneNumberIdTwo = process.env.REACT_APP_PHONE_NUMBER_ID_TWO;
	const textLogic = process.env.REACT_APP_TB_LOGIC ?? [];

	const isPhoneOneError = field?.name === phoneNumberIdOne;
	const isPhoneTwoError = field?.name === phoneNumberIdTwo;

	const shouldValidateNumber = numberValidationIds
		?.split(",")
		.includes(field?.name);

	const isPhoneNumber = phoneNumberIds?.split(",").includes(field?.name);

	const [text, setText] = useState(field?.value || "");
	const [error, setError] = useState({
		show: false,
		message: "",
	});

	const handleChange = (e) => {
		const value = e.target.value;
		if (value.trim() === "") {
			setText("");
			setError({
				show: true,
				message: "value is required",
			});
			hasOthersError(true);
		} else {
			hasOthersError(false);
			if (shouldValidateNumber) {
				if (/\D/.test(value)) {
					setError({
						show: true,
						message: "Only numbers are allowed",
					});
					hasOthersError(true);
				} else {
					if (isPhoneNumber && value.length !== 11) {
						setError({
							show: true,
							message: "Phone number should be 11 digits",
						});
						hasOthersError(true);
					} else {
						setError({ show: false, message: "" });
						hasOthersError(false);
					}
					setText(value);

					field?.onChange?.(e);
					onOtherTextChange({
						id: optionId,
						text: value.trim() === "" ? "NULL" : value,
						type: "TEXT-BOX",
					});
					const targetedId = JSON.parse(textLogic).find(
						(quiz) => quiz.id === field?.name
					)?.next_id;
					if (
						numberLogicIds?.includes(field?.name) &&
						value === "0"
					) {
						onLogicChange({
							action: "REMOVE",
							currentId: Number(field?.name),
							targetedId: Number(targetedId),
						});
					} else {
						onLogicChange({
							action: "ADD",
							currentId: Number(field?.name),
							targetedId: Number(targetedId),
						});
					}
				}
			} else {
				if (/[^A-Za-z\s]/.test(value)) {
					setError({
						show: true,
						message: "Only letters are allowed",
					});
					hasOthersError(true);
				} else {
					setError({ show: false, message: "" });
					hasOthersError(false);
					setText(value);
					field?.onChange?.(e);
					onOtherTextChange({
						id: optionId,
						text: value.trim() === "" ? "NULL" : value,
                        type: "TEXT-BOX"
					});
				}
			}
		}
	};

	useEffect(() => {
		if (text?.trim() === "") {
			setError({
				show: true,
				message: "value is required",
			});
			hasOthersError(true);
		}

		if (isPhoneNumber && text.length !== 11) {
			if (isPhoneOneError) {
				console.log("setting phone one error to true");
				hasPhoneError1(true);
			}
			if (isPhoneTwoError) {
				console.log("setting phone two error to true");
				hasPhoneError2(true);
			}
			setError({
				show: true,
				message: "Phone number should be 11 digits",
			});

			hasOthersError(true);
		}
        if (isPhoneNumber && isPhoneOneError && text.length !== 11) {
			hasPhoneError1(true);
			setError({
				show: true,
				message: "Phone number should be 11 digits",
			});

			hasOthersError(true);
		}

		if (isPhoneNumber && isPhoneTwoError && text.length !== 11) {
			hasPhoneError2(true);
			setError({
				show: true,
				message: "Phone number should be 11 digits",
			});

			hasOthersError(true);
		}

        if (isPhoneNumber && isPhoneTwoError && text.length === 11) {
            hasPhoneError2(false);
			setError({
				show: false,
				message: "",
			});

			hasOthersError(false);
        }

         if (isPhoneNumber && isPhoneOneError && text.length === 11) {
				hasPhoneError1(false);
				setError({
					show: false,
					message: "",
				});

				hasOthersError(false);
			}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [text]);

	return (
		<div
			className={styles.dropdown_wrapper}
			data-testid="textbox_input_container"
		>
			<div className="flex mb-1 gap-2">
				<span className="text-center bg-primary text-white py-[2px] px-1 rounded-sm !text-sm mr-2 block h-6">
					{index + 1}
				</span>
				<p>{question}</p>
			</div>

			<TextField
				{...field}
				id="mainText"
				label="Enter your response"
				variant="outlined"
				size="small"
				className="w-full"
				value={text}
				onChange={handleChange}
				data-testid="textbox_input"
			/>

			{(hasError || error.show) && (
				<small
					className="text-danger mt-1"
					data-testid="textbox_error_element"
				>
					{errorMessage || error.message}
				</small>
			)}
		</div>
	);
};

export default TextBoxInput;
